<script setup lang="ts">
import Field from './Field.vue'
import PitchImage from './PitchImage.vue'

type Props = {
  pitchImageSrc: string
  pitchImageClass?: string
  fieldClass?: string
  fieldUnderlaysClass?: string
}

defineProps<Props>()

// emits
type Emits = {
  fieldClick: [
    {
      event: MouseEvent
      targetElement: HTMLElement
    },
  ]
}

defineEmits<Emits>()
</script>

<template>
  <div class="flex h-full items-center justify-center">
    <div class="relative">
      <Field
        :class="fieldUnderlaysClass"
        :fieldClass
        @click="$emit('fieldClick', $event)"
      >
        <slot name="underlays" />
      </Field>
      <PitchImage
        class="relative"
        :class="pitchImageClass"
        :src="pitchImageSrc"
      />
      <slot name="overlays" />
    </div>
  </div>
</template>
